import { SuperAdminConstants } from '../../../_constants';

const initialState = { combinedMetricListLoading: true, data: '', error: false };

export function combinedMetricListReducer(state = initialState, action) {
    
    switch (action.type) {
        case SuperAdminConstants.REQUEST_COMBINED_METRIC_LIST:
            return {
                combinedMetricListLoading: true,
                data: '',
                error: false
            };
        case SuperAdminConstants.RECEIVE_COMBINED_METRIC_LIST:
            return {
                combinedMetricListLoading: false,
                data: action,
                error: false
            };
        case SuperAdminConstants.COMBINED_METRIC_LIST_ERROR:
            return {
                combinedMetricListLoading: false,
                data: '',
                error: true
            };
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/SuperAdmin/DefineMetric/combinedMetricList.reducer.js